import { identity as M } from "./continuous.js";
import { initInterpolator as g } from "./init.js";
import { linearish as S } from "./linear.js";
import { loggish as q } from "./log.js";
import { copy as f } from "./sequential.js";
import { symlogish as x } from "./symlog.js";
import { powish as I } from "./pow.js";
import L from "../../d3-interpolate/src/piecewise.js";
import P from "../../d3-interpolate/src/value.js";
import j from "../../d3-interpolate/src/round.js";
function s() {
  var n = 0, u = 0.5, m = 1, c = 1, e, t, a, l, y, i = M, p, d = !1, h;
  function o(r) {
    return isNaN(r = +r) ? h : (r = 0.5 + ((r = +p(r)) - t) * (c * r < c * t ? l : y), i(d ? Math.max(0, Math.min(1, r)) : r));
  }
  o.domain = function(r) {
    return arguments.length ? ([n, u, m] = r, e = p(n = +n), t = p(u = +u), a = p(m = +m), l = e === t ? 0 : 0.5 / (t - e), y = t === a ? 0 : 0.5 / (a - t), c = t < e ? -1 : 1, o) : [n, u, m];
  }, o.clamp = function(r) {
    return arguments.length ? (d = !!r, o) : d;
  }, o.interpolator = function(r) {
    return arguments.length ? (i = r, o) : i;
  };
  function v(r) {
    return function(R) {
      var w, k, b;
      return arguments.length ? ([w, k, b] = R, i = L(r, [w, k, b]), o) : [i(0), i(0.5), i(1)];
    };
  }
  return o.range = v(P), o.rangeRound = v(j), o.unknown = function(r) {
    return arguments.length ? (h = r, o) : h;
  }, function(r) {
    return p = r, e = r(n), t = r(u), a = r(m), l = e === t ? 0 : 0.5 / (t - e), y = t === a ? 0 : 0.5 / (a - t), c = t < e ? -1 : 1, o;
  };
}
function z() {
  var n = S(s()(M));
  return n.copy = function() {
    return f(n, z());
  }, g.apply(n, arguments);
}
function A() {
  var n = q(s()).domain([0.1, 1, 10]);
  return n.copy = function() {
    return f(n, A()).base(n.base());
  }, g.apply(n, arguments);
}
function B() {
  var n = x(s());
  return n.copy = function() {
    return f(n, B()).constant(n.constant());
  }, g.apply(n, arguments);
}
function N() {
  var n = I(s());
  return n.copy = function() {
    return f(n, N()).exponent(n.exponent());
  }, g.apply(n, arguments);
}
function T() {
  return N.apply(null, arguments).exponent(0.5);
}
export {
  z as default,
  A as divergingLog,
  N as divergingPow,
  T as divergingSqrt,
  B as divergingSymlog
};
